import { Alert, Box, Typography } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LinkConstants from "../../../../constants/LinkConstants.ts";
import BestPracticesPopup from "../../../../pages/NewTG/Models/Popups/BestPractices/BestPracticesPopup.tsx";
import BriaButton from "../../../common/BriaButton/BriaButton.tsx";
import VideoPopup from "../../../Popups/VideoPopup/VideoPopup.tsx";
import styles from "./McpServerInstallSection.module.scss";
import { Environment, getCurrentEnv } from "../../../../config/env.ts";
import ClaudeTutorial from "../../../../assets/McpServer/videos/claude-tutorial.mp4"
import { useLogEvents } from "../../../../hooks/useLogEvents";

const McpServerInstallSection = () => {
	const { t } = useTranslation("translation", { keyPrefix: "mcpServer.installSection" });
	const { logImageGenerationMcpCopyUrlClick } = useLogEvents();
	const [openBestPracticesPopup, setOpenBestPracticesPopup] = useState(false);
	const [openVideoExamplePopup, setOpenVideoExamplePopup] = useState(false);
	const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

	const getMcpServerLink = () => {
		switch (getCurrentEnv()) {
			case Environment.production:
				return LinkConstants.BRIA_MCP_SERVER_PROD;
			case Environment.integration:
				return LinkConstants.BRIA_MCP_SERVER_INT;
			default:
				return LinkConstants.BRIA_MCP_SERVER_PROD;
		}
	}

	const handleCopyUrl = async () => {
		await navigator.clipboard.writeText(getMcpServerLink());
		setIsSnackbarOpen(true);
		logImageGenerationMcpCopyUrlClick();
	};

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<Box className={styles.cardsSection}>
				<Box className={styles.card}>
					<Box className={styles.cardTextSection}>
						<Typography className={styles.cardTitle}>{t("configureCard.title")}</Typography>
						<Typography className={styles.cardDescription}>{t("configureCard.description")}</Typography>
						<Typography
							component={"a"}
							className={styles.exampleLink}
							onClick={() => setOpenVideoExamplePopup(true)}
						>
							{t("configureCard.exampleLink")}
						</Typography>
					</Box>
					<BriaButton buttonType={"primaryMedium"} onClick={handleCopyUrl}>
						{t("configureCard.copyUrlButton")}
					</BriaButton>
				</Box>
				<Box className={styles.card}>
					<Box className={styles.cardTextSection}>
						<Typography className={styles.cardTitle}>{t("startBriaCard.title")}</Typography>
						<Typography className={styles.cardDescription}>{t("startBriaCard.description")}</Typography>
					</Box>
				</Box>
			</Box>
			<BestPracticesPopup open={openBestPracticesPopup} onClose={() => setOpenBestPracticesPopup(false)} />
			<VideoPopup
				isOpen={openVideoExamplePopup}
				onClose={() => setOpenVideoExamplePopup(false)}
				videoSrc={ClaudeTutorial}
			/>
			<Snackbar open={isSnackbarOpen} autoHideDuration={2000} onClose={() => setIsSnackbarOpen(false)}>
				<Alert onClose={() => setIsSnackbarOpen(false)} severity="success">
					{t("configureCard.copyToClipboardSuccess")}
				</Alert>
			</Snackbar>
		</Box>
	);
};

export default McpServerInstallSection;
